{
  "quarter_audiences": ["small_group", "large_group_custom"],
  "annual_audiences": ["individual", "level_funded", "medicare_advantage"],
  "ancillary_product_lines": ["accident", "dental", "disability", "life", "vision", "hospital_indemnity", "critical_illness"],
  "feature_flag_keys": ["network", "formulary", "ichra_affordability", "issuers_with_qualifications", "disruption_analysis", "mcp_access", "plan_library_limited"]
}
